import type { Layout } from '@/models/layout/layout.class'
import type { ComputedRef, InjectionKey } from 'vue'

export type LayoutVariant = 'kama' | 'vuetify'

export interface LayoutContext {
  useGrid: boolean
  variant: LayoutVariant
  ignoreLayout: boolean
}

// Каждый вложенный контейнер задаёт собственную раскладку для своих элементов.
export const layoutKey: InjectionKey<ComputedRef<LayoutContext>> = Symbol('layout')

export const getColParams = (layout: Layout | null | undefined) => {
  if (!layout) return {}

  return layout.useCol
    ? { xl: layout.xl, lg: layout.lg, md: layout.md, sm: layout.sm }
    : { cols: 12 }
}
